import { AlarmLevel } from './alarm-level';
import { MotorChannelType } from './channel-type';

export interface DefaultValues {
    measurableMax?: number;
    measurableMin?: number;
    unit?: string;
    scale?: number;
    alarmRecoveryHysteresis?: number;
    digitalInputFilter?: number;
    signalWidth?: number;
}

export const analogChannelDefaultValues: DefaultValues = {
    measurableMax: 0,
    measurableMin: 0,
    alarmRecoveryHysteresis: 1,
};

export const runningHourDefaultValues: DefaultValues = {
    measurableMax: 999999959,
    measurableMin: 0,
    unit: 'HR.M',
    scale: 100,
};

export const flowCounterDefaultValues: DefaultValues = {
    measurableMax: 999999999,
    measurableMin: 0,
    scale: 1,
    digitalInputFilter: 10,
};

export const digitalDefaultRange: DefaultValues = {
    digitalInputFilter: 10,
    signalWidth: 500,
};

export const exhaustDefaultValues: DefaultValues = {
    measurableMax: 0,
    measurableMin: 0,
    alarmRecoveryHysteresis: 1,
};

export interface DefaultAlarm {
    enable?: boolean;
    status?: string;
    onStatus?: string;
    offStatus?: string;
    motorType?: MotorChannelType;
    setPoint?: number;
    alarmGroupNo: number;
    reposeGroup1No: number;
    reposeGroup2No: number;
    delay: number;
    alarm: AlarmLevel;
    normalOpenFlag?: boolean;
}

export const hhAlarmDefaults: DefaultAlarm = {
    status: 'HH',
    setPoint: 0,
    alarmGroupNo: 1,
    reposeGroup1No: 0,
    reposeGroup2No: 0,
    delay: 0,
    alarm: AlarmLevel.Alarm,
};

export const hAlarmDefaults: DefaultAlarm = {
    status: 'HIGH',
    setPoint: 0,
    alarmGroupNo: 1,
    reposeGroup1No: 0,
    reposeGroup2No: 0,
    delay: 0,
    alarm: AlarmLevel.Alarm,
};
export const llAlarmDefaults: DefaultAlarm = {
    status: 'LL',
    setPoint: 0,
    alarmGroupNo: 1,
    reposeGroup1No: 0,
    reposeGroup2No: 0,
    delay: 0,
    alarm: AlarmLevel.Alarm,
};
export const lAlarmDefaults: DefaultAlarm = {
    status: 'LOW',
    setPoint: 0,
    alarmGroupNo: 1,
    reposeGroup1No: 0,
    reposeGroup2No: 0,
    delay: 0,
    alarm: AlarmLevel.Alarm,
};

export const sensorFailureDefaults: DefaultAlarm = {
    status: 'FAIL',
    alarmGroupNo: 1,
    reposeGroup1No: 0,
    reposeGroup2No: 0,
    delay: 0,
    alarm: AlarmLevel.Alarm,
};

export const motorAlarmDefaults: DefaultAlarm = {
    enable: true,
    motorType: MotorChannelType.RUN,
    alarmGroupNo: 1,
    reposeGroup1No: 0,
    reposeGroup2No: 0,
    delay: 0,
    alarm: AlarmLevel.Alarm,
};
export const digitalAlarmDefaults: DefaultAlarm = {
    onStatus: 'ON',
    offStatus: 'OFF',
    alarmGroupNo: 1,
    reposeGroup1No: 0,
    reposeGroup2No: 0,
    delay: 0,
    normalOpenFlag: true,
    alarm: AlarmLevel.Alarm,
};

export const feedbackAlarmDefaults: DefaultAlarm = {
    status: 'FB',
    alarmGroupNo: 1,
    reposeGroup1No: 0,
    reposeGroup2No: 0,
    delay: 0,
    alarm: AlarmLevel.Alarm,
};

export const systemAlarmDefaults: DefaultAlarm = {
    enable: true,
    alarmGroupNo: 1,
    reposeGroup1No: 0,
    reposeGroup2No: 0,
    delay: 0,
    alarm: AlarmLevel.Alarm,
};
